import { FC } from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyle = makeStyles((theme) => ({
  root: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.error.main,
  },
}))

const RequiredLabelText: FC = () => {
  const classes = useStyle()
  return (
    <span className={classes.root} data-testid="TextField-RequiredLabelText">
      (필수)
    </span>
  )
}

export default RequiredLabelText
